
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[storeTag]",
      function () {
        return require("private-next-pages/[storeTag]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[storeTag]"])
      });
    }
  